<app-year-filter-select
  #fromYear
  class="year-range-filter__year"
  [form]="form"
  [controlName]="fromControlName"
  [label]="fromLabel"
  [minYear]="minYear"
  [maxYear]="maxYear"
  [maxYearAddition]="maxYearAddition"
  [omitValues]="fromOmit"
  [noneEnabled]="true"
  [noneLabel]="anyLabel"
  [defaultValue]="-1"
  (valueChanged)="onYearChange()"></app-year-filter-select>

<span class="year-range-filter__dash" aria-hidden="true">–</span>

<app-year-filter-select
  #toYear
  class="year-range-filter__year"
  [form]="form"
  [controlName]="toControlName"
  [label]="toLabel"
  [minYear]="minYear"
  [maxYear]="maxYear"
  [maxYearAddition]="maxYearAddition"
  [omitValues]="toOmit"
  [noneEnabled]="true"
  [noneLabel]="anyLabel"
  [defaultValue]="-1"
  (valueChanged)="onYearChange()"></app-year-filter-select>
